import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Route is /organizations/$organizationId (index): it redirects to the members
 * subpage, the default organization landing. The organization shell has no content
 * of its own, so the bare org path forwards to the first subpage.
 */
export const Route = createFileRoute("/_app/organizations/$organizationId/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      params: { organizationId: params.organizationId },
      to: "/organizations/$organizationId/members",
    });
  },
});
